import { useQuery } from "@apollo/client";

import { GqlFieldworkerPreferredTransportationMethod } from "~/__generated__";

import { PlannerV2FieldworkersGetPlannableForVisitDocument } from "../queries.generated";

export default function usePlannerV2FieldworkersGetPlannableForVisit({
    onDate,
    plannerVisitId,
    timeslotId,
    transportationMethods,
    fieldworkerIds,
    includeUnavailable,
}: {
    onDate: string;
    plannerVisitId: string;
    timeslotId?: string;
    transportationMethods?: GqlFieldworkerPreferredTransportationMethod[];
    fieldworkerIds?: string[];
    includeUnavailable?: boolean;
}) {
    const { data, loading, error } = useQuery(PlannerV2FieldworkersGetPlannableForVisitDocument, {
        variables: {
            onDate,
            plannerVisitId,
            timeslotId: timeslotId ?? "",
            transportationMethods,
            fieldworkerIds,
            includeUnavailable,
        },
        skip: !timeslotId,
        errorPolicy: "all",
    });

    return {
        loading,
        error,
        data: {
            availableFieldworkers: data?.plannerV2FieldworkersGetPlannableForVisit,
        },
    };
}
